// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 35%;
}

@media only screen and (min-width: 720px) {
  .dashboard-section-title {
    font-size: 1.5rem;
    text-align: center;
    margin-top: 3em;
  }
}
@media only screen and (max-width: 720px) {
  .dashboard-section-title {
    font-size: 1.25rem;
    text-align: center;
    margin-bottom: 1em;
    margin-top: 4em;
  }
}
.dashboard-return-footer {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
  padding: 0 8px;
}

.dashboard-footer-line {
  flex: 1;
  height: 3px;
  background-color: var(--ion-color-medium, #92949c);
  opacity: 0.4;
}

.dashboard-return-btn {
  --border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  min-width: 160px;
}

.dashboard-filter-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 16px 16px;
  color: var(--ion-color-primary-contrast);
}

.dashboard-filter-icon {
  font-size: 1.4rem;
  opacity: 0.7;
}

.dashboard-filter-title {
  font-size: 1.4rem;
  font-weight: 500;
}

.dashboard-welcome-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.5em;
  max-width: 600px;
}

.dashboard-welcome-text {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4em;
}

.dashboard-welcome-title {
  color: var(--ion-color-secondary-contrast);
  font-weight: 490;
  letter-spacing: 0.3px;
  display: block;
  line-height: 1.2;
}

.dashboard-welcome-subtitle {
  color: var(--ion-color-secondary-contrast);
  opacity: 0.75;
  font-size: 1.25rem;
  display: block;
}

@media only screen and (min-width: 720px) {
  .dashboard-welcome-title {
    font-size: 2rem;
  }
}
@media only screen and (max-width: 720px) {
  .dashboard-welcome-title {
    font-size: 1.5rem;
  }
  .dashboard-welcome-card {
    margin: 0 1em 1.5em;
    padding: 1.25em 1.25em;
  }
}
.dashboard-section {
  padding-bottom: 36px;
}

.section-list {
  display: flex;
  justify-content: center;
}

.section-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 1500px;
}

.dashboard-section-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 16px 16px;
}

.dashboard-section-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.dashboard-section-title {
  font-size: 1.5rem;
  font-weight: 600;
  white-space: nowrap;
  letter-spacing: 0.2px;
}

.dashboard-section-header.is-collapsable .dashboard-section-divider {
  background: linear-gradient(to right, var(--ion-color-success) 0%, transparent 100%);
  opacity: 0.4;
}

.dashboard-section-divider {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, var(--ion-color-medium) 0%, transparent 100%);
  opacity: 0.35;
}

.group-header-chip {
  --color: var(--ion-color-primary-contrast);
  font-size: 1.2rem;
  height: 42px;
  flex-shrink: 0;
}

.dashboard-subgroup {
  padding-bottom: 24px;
}

.dashboard-subgroup-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0 32px 12px;
}

.subgroup-header-chip {
  --color: var(--ion-color-primary-contrast);
  font-size: 1.1rem;
  height: 36px;
  flex-shrink: 0;
  opacity: 0.9;
}

.dashboard-section-header.is-collapsable .dashboard-section-icon {
  opacity: 1;
}
.dashboard-section-header.is-collapsable .dashboard-section-label {
  opacity: 0.85;
}
.dashboard-section-header.is-collapsable .dashboard-section-divider {
  background: linear-gradient(to right, var(--ion-color-success) 0%, transparent 100%);
  opacity: 0.35;
}

.dashboard-section-divider {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, var(--ion-color-medium) 0%, transparent 100%);
  opacity: 0.35;
}

.empty-reports-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 5em;
  gap: 12px;
}

.empty-reports-icon {
  font-size: 3.5rem;
}

.empty-reports-text {
  color: var(--ion-color-primary-contrast);
  font-size: 1.2rem;
  font-weight: 450;
  opacity: 0.7;
}

@media only screen and (max-width: 720px) {
  .dashboard-section {
    padding-bottom: 28px;
  }
  .dashboard-section-title {
    font-size: 1rem;
  }
}
@media only screen and (min-width: 1101px) {
  #dashboard {
    margin-left: 3em;
    margin-right: 3em;
  }
}
@media only screen and (min-width: 2100px) {
  #dashboard {
    margin-left: 3em;
    margin-right: 3em;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/home/pages/dashboard/dashboard.component.scss"],"names":[],"mappings":"AACA;EACE,cAAA;AAAF;;AAGA;EACE;IACE,iBAAA;IACA,kBAAA;IAEA,eAAA;EADF;AACF;AAIA;EACE;IACE,kBAAA;IACA,kBAAA;IACA,kBAAA;IACA,eAAA;EAFF;AACF;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;AAJF;;AAOA;EACE,OAAA;EACA,WAAA;EACA,kDAAA;EACA,YAAA;AAJF;;AAOA;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAJF;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,wCAAA;AAJF;;AAOA;EACE,iBAAA;EACA,YAAA;AAJF;;AAOA;EACE,iBAAA;EACA,gBAAA;AAJF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,gBAAA;AALF;;AASA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,UAAA;AANF;;AASA;EACE,0CAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;AANF;;AASA;EACE,0CAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;AANF;;AAUA;EACE;IACE,eAAA;EAPF;AACF;AAUA;EACE;IACE,iBAAA;EARF;EAUA;IACE,mBAAA;IACA,sBAAA;EARF;AACF;AAWA;EACE,oBAAA;AATF;;AAYA;EACE,aAAA;EACA,uBAAA;AATF;;AAYA;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;AATF;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AATF;;AAaA;EACE,iBAAA;EACA,cAAA;AAVF;;AAcA;EACE,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAXF;;AAeA;EACE,oFAAA;EACA,YAAA;AAZF;;AAeA;EACE,OAAA;EACA,WAAA;EACA,mFAAA;EACA,aAAA;AAZF;;AAgBA;EAEE,0CAAA;EACA,iBAAA;EAEA,YAAA;EACA,cAAA;AAfF;;AAmBA;EACE,oBAAA;AAhBF;;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAhBF;;AAoBA;EAEE,0CAAA;EACA,iBAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;AAlBF;;AAuBE;EAEE,UAAA;AArBJ;AAuBE;EAEE,aAAA;AAtBJ;AA2BE;EACE,oFAAA;EAKA,aAAA;AA7BJ;;AAiCA;EACE,OAAA;EACA,WAAA;EACA,mFAAA;EAKA,aAAA;AAlCF;;AAwCA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;AArCF;;AAwCA;EACE,iBAAA;AArCF;;AAyCA;EACE,wCAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;AAtCF;;AAyCA;EACE;IACE,oBAAA;EAtCF;EAwCA;IACE,eAAA;EAtCF;AACF;AA0CA;EACE;IACE,gBAAA;IACA,iBAAA;EAxCF;AACF;AA2CA;EACE;IACE,gBAAA;IACA,iBAAA;EAzCF;AACF","sourcesContent":["\nimg {\n  max-width: 35%;\n}\n\n@media only screen and (min-width: 720px) {\n  .dashboard-section-title {\n    font-size: 1.5rem;\n    text-align: center;\n    // margin-bottom: 1em;\n    margin-top: 3em;\n  }\n}\n\n@media only screen and (max-width: 720px) {\n  .dashboard-section-title {\n    font-size: 1.25rem;\n    text-align: center;\n    margin-bottom: 1em;\n    margin-top: 4em;\n  }\n}\n\n// Return footer\n.dashboard-return-footer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-top: 32px;\n  padding: 0 8px;\n}\n\n.dashboard-footer-line {\n  flex: 1;\n  height: 3px;\n  background-color: var(--ion-color-medium, #92949c);\n  opacity: 0.4;\n}\n\n.dashboard-return-btn {\n  --border-radius: 8px;\n  font-weight: 600;\n  font-size: 1rem;\n  min-width: 160px;\n}\n\n.dashboard-filter-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 16px 16px;\n  color: var(--ion-color-primary-contrast);\n}\n\n.dashboard-filter-icon {\n  font-size: 1.4rem;\n  opacity: 0.7;\n}\n\n.dashboard-filter-title {\n  font-size: 1.4rem;\n  font-weight: 500;\n}\n\n// Welcome card styles\n.dashboard-welcome-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 1.5em;\n  max-width: 600px;\n  // padding: 1.75em 2em;\n}\n\n.dashboard-welcome-text {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.4em;\n}\n\n.dashboard-welcome-title {\n  color: var(--ion-color-secondary-contrast);\n  font-weight: 490;\n  letter-spacing: 0.3px;\n  display: block;\n  line-height: 1.2;\n}\n\n.dashboard-welcome-subtitle {\n  color: var(--ion-color-secondary-contrast);\n  opacity: 0.75;\n  font-size: 1.25rem;\n  display: block;\n}\n\n\n@media only screen and (min-width: 720px) {\n  .dashboard-welcome-title {\n    font-size: 2rem;\n  }\n}\n\n@media only screen and (max-width: 720px) {\n  .dashboard-welcome-title {\n    font-size: 1.5rem;\n  }\n  .dashboard-welcome-card {\n    margin: 0 1em 1.5em;\n    padding: 1.25em 1.25em;\n  }\n}\n// ── Sections layout ────────────────────────────────────────────\n.dashboard-section {\n  padding-bottom: 36px;\n}\n\n.section-list {\n  display: flex;\n  justify-content: center;\n}\n\n.section-cards {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 1500px;\n}\n\n.dashboard-section-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 0 16px 16px;\n}\n\n// Collection header: icon + title + accent divider\n.dashboard-section-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n  // color: var(--ion-color-success);\n}\n\n.dashboard-section-title {\n  font-size: 1.5rem;\n  font-weight: 600;\n  white-space: nowrap;\n  letter-spacing: 0.2px;\n  // color: var(--ion-color-success);\n}\n\n.dashboard-section-header.is-collapsable .dashboard-section-divider {\n  background: linear-gradient(to right, var(--ion-color-success) 0%, transparent 100%);\n  opacity: 0.4;\n}\n\n.dashboard-section-divider {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(to right, var(--ion-color-medium) 0%, transparent 100%);\n  opacity: 0.35;\n}\n\n// ion-chip: plain group section header\n.group-header-chip {\n  // --background: var(--ion-color-secondary);\n  --color: var(--ion-color-primary-contrast);\n  font-size: 1.2rem;\n  // font-weight: 700;\n  height: 42px;\n  flex-shrink: 0;\n}\n\n// ── Sub-group inside a collapsable section ─────────────────────\n.dashboard-subgroup {\n  padding-bottom: 24px;\n}\n\n.dashboard-subgroup-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin: 0 32px 12px;\n}\n\n// ion-chip: sub-group header inside a collection\n.subgroup-header-chip {\n  // --background: rgba(var(--ion-color-medium-rgb), 0.1);\n  --color: var(--ion-color-primary-contrast);\n  font-size: 1.1rem;\n  height: 36px;\n  flex-shrink: 0;\n  opacity: 0.9;\n}\n\n// Collapsable (multi-group collection) — accent with success tint\n.dashboard-section-header.is-collapsable {\n  .dashboard-section-icon {\n    // color: var(--ion-color-success);\n    opacity: 1;\n  }\n  .dashboard-section-label {\n    // color: var(--ion-color-success);\n    opacity: 0.85;\n  }\n  // .dashboard-section-title {\n  //   // color: var(--ion-color-success);\n  // }\n  .dashboard-section-divider {\n    background: linear-gradient(\n      to right,\n      var(--ion-color-success) 0%,\n      transparent 100%\n    );\n    opacity: 0.35;\n  }\n}\n\n.dashboard-section-divider {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(\n    to right,\n    var(--ion-color-medium) 0%,\n    transparent 100%\n  );\n  opacity: 0.35;\n}\n\n\n\n// ── Empty state ────────────────────────────────────────────────\n.empty-reports-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 5em;\n  gap: 12px;\n}\n\n.empty-reports-icon {\n  font-size: 3.5rem;\n  // color: var(--ion-color-medium);\n}\n\n.empty-reports-text {\n  color: var(--ion-color-primary-contrast);\n  font-size: 1.2rem;\n  font-weight: 450;\n  opacity: 0.7;\n}\n\n@media only screen and (max-width: 720px) {\n  .dashboard-section {\n    padding-bottom: 28px;\n  }\n  .dashboard-section-title {\n    font-size: 1rem;\n  }\n}\n\n// Override global.scss large percentage margins so report cards fill the available width\n@media only screen and (min-width: 1101px) {\n  #dashboard {\n    margin-left: 3em;\n    margin-right: 3em;\n  }\n}\n\n@media only screen and (min-width: 2100px) {\n  #dashboard {\n    margin-left: 3em;\n    margin-right: 3em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
